<template>
  <div>
    <b-form
      novalidate
      @submit.prevent="submit"
    >
      <validation-observer ref="createBusinessRef">
        <b-card>
          <b-row>
            <b-col md="12">
              <h3>Business Details</h3>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Business Name En"
                rules="required"
              >
                <b-form-group
                  label="Business Name En"
                  label-for="business-name-en"
                >
                  <b-form-input
                    id="business-name-en"
                    v-model="businessData.businessName.en"
                    placeholder="Business Name En"
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Business Name Ar"
                rules="required"
              >
                <b-form-group
                  label="Business Name Ar"
                  label-for="business-name-ar"
                >
                  <b-form-input
                    id="business-name-ar"
                    v-model="businessData.businessName.ar"
                    placeholder="Business Name Ar"
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Business Email"
                rules="required"
              >
                <b-form-group
                  label="Business Email"
                  label-for="business-email"
                >
                  <b-form-input
                    id="business-email"
                    v-model="businessData.businessEmail"
                    placeholder="Business Email"
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Business Phone No."
                rules="required"
              >
                <b-form-group
                  label="Business Phone No."
                  label-for="business-email"
                >
                  <b-form-input
                    id="business-phone-no"
                    v-model="businessData.businessPhoneNumber"
                    placeholder="Business Phone No."
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Business Type"
                label-for="business-type"
              >
                <v-select
                  id="business-type"
                  v-model="businessData.businessTypes"
                  :clearable="false"
                  placeholder="Business Type"
                  :options="businessTypes"
                  :reduce="val => val.id"
                  :loading="fetchingBusinessTypes"
                  :disabled="fetchingBusinessTypes || isOtpStage"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <h3>Primary Contact</h3>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-group
                  label="Name"
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    v-model="businessData.name"
                    placeholder="Name"
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required"
              >
                <b-form-group
                  label="Email"
                  label-for="email"
                >
                  <b-form-input
                    id="email"
                    v-model="businessData.email"
                    placeholder="Email"
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Phone No"
                rules="required"
              >
                <b-form-group
                  label="Phone No"
                  label-for="phone-no"
                >
                  <b-form-input
                    id="phone-no"
                    v-model="businessData.phoneNumber"
                    placeholder="Ex: +962787570753"
                    :disabled="isOtpStage"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-form-group
                  label="Password"
                  label-for="business-password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="business-password"
                      v-model="businessData.password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :disabled="isOtpStage"
                      :type="passwordFieldType"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="8" />
            <b-col
              md="4"
              class="d-flex align-items-center justify-content-center"
            >
              <b-button
                block
                variant="primary"
                type="submit"
                :disabled="submitting || isOtpStage || fetchingBusinessTypes"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>Submit</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </validation-observer>
    </b-form>
    <b-row v-if="isOtpStage">
      <b-col md="6">
        <b-form-group
          label="OTP"
          label-for="business-email-top"
        >
          <b-form-input
            id="business-email-top"
            v-model="otpCode"
            :placeholder="`Enter OTP sent to ${businessData.email}`"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="d-flex justify-content-between align-items-center"
      >
        <b-button
          variant="primary"
          :disabled="submittingCode || otpCode.length < 6 || businessVerified"
          @click="confirmBusiness"
        >
          <b-spinner
            v-if="submittingCode"
            small
          />
          Confirm business
        </b-button>
        <b-button
          variant="danger"
          :disabled="submittingCode || businessVerified"
          @click="forceConfirmBusiness"
        >
          <b-spinner
            v-if="submittingCode"
            small
          />
          Force Confirm business
        </b-button>
        <b-button
          v-if="businessVerified"
          variant="primary"
          @click="gotoProfile"
        >
          Go to profile
        </b-button>
      </b-col>
    </b-row>
    <!-- <b-button @click="$emit('next')">next</b-button> -->
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BSpinner,
  BInputGroupAppend,
  BInputGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ref, computed } from '@vue/composition-api'
import useCreate from '../../hooks/useCreate'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../../store'

export default {
  components: {
    BCard,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    BFormInput,
    BSpinner,
    ValidationProvider,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    vSelect,
    BCol,
  },
  // props: {
  //   logicalId: {
  //     type: String,
  //     required: true,
  //   },
  // },
  setup(props, ctx) {
    const passwordFieldType = ref('password')
    const passwordToggleIcon = computed(() => (passwordFieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))
    const togglePasswordVisibility = () => {
      passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password'
    }
    useRegisterStoreModule('business', businessStore)
    return {
      required,
      passwordFieldType,
      passwordToggleIcon,
      togglePasswordVisibility,
      ...useCreate(props, ctx),
    }
  },
}
</script>

<style>

</style>
